interface ScrollTarget {
  scrollTo?: number;
  ref?: HTMLElement;
}
export const onClickScrollToTarget = (target?: ScrollTarget): void => {
  if (target && target.ref && typeof target.ref.scrollIntoView === 'function') {
    target.ref.scrollIntoView({
      block: 'start'
    });
  } else if (target && typeof target.scrollTo !== 'undefined') {
    window.scrollTo(0, target.scrollTo);
  }
};
